<template>
  <div id="infopage">
    <Banner
      id="home-page-banner"
      :content="bannerText"
      :visible="isBannerVisible"
      :has-background-color="true"
    />
    <div class="mx-auto my-10 text-neutral-900 md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl mobile:my-3">
      <EditableArea
        v-if="area1"
        :content="area1"
      />
      <EditableArea
        v-if="area2"
        :content="area2"
      />
      <EditableArea
        v-if="area3"
        :content="area3"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { EditableArea } from '@magnolia/vue-editor';
import type InfoPage from '~/templates/pages/InfoPage/InfoPage.model';

const { bannerText = undefined, showBanner = false } = defineProps<InfoPage>();

const isBannerVisible = computed(() => showBanner ?? false);
</script>
